import * as React from "react";

export const useSwipe = () => {
  const [isSwiped, setIsSwiped] = React.useState(false);

  const setSwipedState = React.useCallback((isSwiped: boolean) => {
    setIsSwiped(isSwiped);
  }, []);

  return { isSwiped, setSwipedState };
};
